import { createTimeline } from "./createTimeline";

export const opportunityTimeline = createTimeline({
  name: "opportunityTimeline",
  selectState: (state) => state.opportunity.opportunityTimeline,
});

export const proposalTimeline = createTimeline({
  name: "proposalTimeline",
  selectState: (state) => state.proposals.proposalTimeline,
});

export const dueDateTimeline = createTimeline({
  name: "dueDateTimeline",
  selectState: (state) => state.opportunity.dueDateTimeline,
  initialScaleIndex: 3,
});

export const proposalDueDateTimeline = createTimeline({
  name: "proposalDueDateTimeline",
  selectState: (state) => state.proposals.proposalDueDateTimeline,
  initialScaleIndex: 3,
});
